export default function useValidators(validators = []) {
  return (value) => (
    validators.reduce((error, validator) => (
      error || validator(value)
    ), undefined)
  );
}
